import { environment } from 'src/environment';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { SeoService } from 'src/app/core/services/seo.service';
import { StaticService } from 'src/app/core/services/static.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-static',
  templateUrl: './static.component.html',
  styleUrls: ['./static.component.scss']
})
export class StaticComponent implements OnInit, OnDestroy {
  type: any;
  page: any;
  heading: any;
  description: any;
  pageH1Tag;
  startState;
  homeImage: any;

  skinName = environment.skinName;
  constructor(public route: ActivatedRoute, public staticService: StaticService, public settingsService: SettingsService,
    private baseService: BaseService, private storageService: StorageService, private seoService: SeoService, private analyticsService: InhouseAnalyticsService) {
    this.homeImage = this.settingsService.homeImage;
    this.settingsService.showHeader = false;
    this.settingsService.showFooter = true;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.type = params.type;
      let footerDiv = document.getElementById('footer-description');
      footerDiv.scrollTop = 0;
      this.getFooterDetails();
    });
    if (this.baseService.loginMode === 0) {
      if (!this.storageService.getLocalStore('u_id')) {
        this.baseService.guestSource.next(true);
      }
      this.startState = '/home';
    } else {
      this.startState = '/auth/signup';
    }
  }

  getFooterDetails() {
    this.baseService.loaderSource.next(true);
    this.staticService.getfooterDetails(this.type)
      .subscribe({
        next: data => {
          this.baseService.loaderSource.next(false);
          this.page = data.page;
          this.heading = this.page.heading;
          this.description = this.page.description;

          const eventObj = {
            event_type: 'Page View',
            event_name: `${this.heading} Page View`,
            event_status: 'Success',
          };
          this.analyticsService.trackUserActions(eventObj);

          if (this.page.meta_title) {
            this.seoService.setMetatitle(this.page.meta_title);
          }
          if (this.page.meta_keywords) {
            const metaData = { name: 'keywords', content: this.page.meta_keywords };
            this.seoService.updateMetaTags(metaData);
          }
          if (this.page.meta_description) {
            const metaData = { name: 'description', content: this.page.meta_description };
            this.seoService.updateMetaTags(metaData);
          }
          if (this.page.h1_tag) {
            this.seoService.pageH1Tag.next(this.page.h1_tag);
          }
        }
      });
  }

  ngOnDestroy() {
    this.settingsService.showHeader = true;
    this.settingsService.showFooter = true;
    this.seoService.defaultMetaTag();
  }
}
